export default {
  company: 'Company',
  franchise: 'Franchise',
  admin: 'Admin account',
  user: 'User',
  technician: 'Technician',
  priceff: 'Priceff'
}